(function(){
  function initNavHandlers(navEl){
    if(!navEl)return;
    navEl.addEventListener('click',function(e){
      var t=e.target.closest('.site-nav__toggle');
      if(!t)return;
      e.preventDefault();
      var l=t.closest('li.site-nav--has-submenu');
      if(!l)return;
      var w=l.querySelector('.site-nav__submenu-wrap');
      var o=w&&getComputedStyle(w).display!=='none';
      if(o){
        if(w)w.style.display='none';
        t.setAttribute('aria-expanded','false');
        var d=l.querySelector('.columns.is-mobile');
        if(d)d.classList.remove('is-open');
      }else{
        if(w)w.style.display='block';
        w.setAttribute('data-panel','t2');
        t.setAttribute('aria-expanded','true');
        var d=l.querySelector('.columns.is-mobile');
        if(d)d.classList.add('is-open');
        navEl.querySelectorAll(':scope > li.site-nav--has-submenu').forEach(function(b){
          if(b!==l){
            var bw=b.querySelector(':scope > .site-nav__submenu-wrap');
            var bt=b.querySelector(':scope > .columns .site-nav__toggle');
            if(bw)bw.style.display='none';
            if(bt)bt.setAttribute('aria-expanded','false');
            var bd=b.querySelector(':scope > .columns.is-mobile');
            if(bd)bd.classList.remove('is-open');
          }
        });
      }
    });
    navEl.addEventListener('click',function(e){
      var a=e.target.closest('[data-open-tier3]');
      if(!a)return;
      e.preventDefault();
      var w=a.closest('.site-nav__submenu-wrap');
      if(!w)return;
      var c=a.getAttribute('data-category');
      var u=a.getAttribute('data-subcategory');
      var r=a.getAttribute('data-title')||'';
      var cb=w.querySelector('[data-tier3-crumb]');
      if(cb)cb.textContent=r;
      w.querySelectorAll('.site-nav__tier3-section').forEach(function(x){x.style.display='none'});
      var sec=w.querySelector('.site-nav__tier3-section[data-category="'+c+'"][data-subcategory="'+u+'"]');
      if(sec)sec.style.display='block';
      w.setAttribute('data-panel','t3');
      requestAnimationFrame(function(){
        var p=w.querySelector('.site-nav__panel--t3');
        var tg=p||w;
        if(tg)tg.scrollIntoView({block:'start',behavior:'smooth',inline:'nearest'});
      });
    });
    navEl.addEventListener('click',function(e){
      var b=e.target.closest('[data-back-tier2]');
      if(!b)return;
      var w=b.closest('.site-nav__submenu-wrap');
      if(w)w.setAttribute('data-panel','t2');
    });
  }
  var siteNav=document.getElementById('siteNav');
  var siteNavM=document.getElementById('siteNavM');
  initNavHandlers(siteNav);
  initNavHandlers(siteNavM);
})();